import React from 'react';
// import { PropTypes } from 'prop-types';
import Icon from '../../../componentsV2/Icons/Icon';
import HeaderWithBreadcrumbs from '../../../componentsV2/Headers/HeaderWithBreadcrumbs';

const breadcrumbLinks = [
  { href: '/help', name: 'Help' },
];

const HelpPage = () => {
  return (
    <div className="mx-2.75">
      <header>
        <HeaderWithBreadcrumbs links={breadcrumbLinks} name="help" label="Help" size="h-9" />
      </header>
      <div className="ml-9.5">
        <h2 className="text-lg font-medium">Resources</h2>
        <p className="pb-5.5 text-base font-normal">Find guides, tutorials, and get support to make the most of Vamos.</p>
        <div className="flex justify-between space-x-7.75 pb-11.5">
          <div className="w-1/3 p-4 bg-vamos-white rounded-10px shadow-md flex flex-col justify-between">
            <div className="flex items-center gap-x-2 mb-3">
              <div className=""><Icon name="user_guide" /></div>
              <h3 className="text-md font-bold">User guide</h3>
            </div>
            <p className="flex-grow mb-3">Everything you need to know to use Vamos, from basic setup to advanced features.
            </p>
            <a href="https://docs.google.com/document/d/1M7dB9txljYhpIDLA7gDzMoGdD2qVJ7XZcnvUSu7GwUY/edit?usp=sharing" target="#" className="flex items-center justify-center p-2.5 rounded-md bg-vamos-v-light-gray hover:bg-vamos-light-gray">
              <span>View the user guide</span>
            </a>
          </div>
          <div className="w-1/3 p-4 bg-vamos-white rounded-10px shadow-md flex flex-col justify-between">
            <div className="flex items-center gap-x-2 mb-3">
              <div className=""><Icon name="data_guide" /></div>
              <h3 className="text-md font-bold">Data import guide</h3>
            </div>
            <p className="flex-grow mb-3">Instructions for importing your data, including supported formats and best practices.
            </p>
            <a href="https://docs.google.com/document/d/1wJijOJokFYzAdikGchZh1rD_qg3Wb2Yibpz8Aju8Zpg/edit?usp=sharing" target="#" className="flex items-center justify-center p-2.5 rounded-md bg-vamos-v-light-gray hover:bg-vamos-light-gray">
              <span>View the import guide</span>
            </a>
          </div>
          <div className="w-1/3 p-4 bg-vamos-white rounded-10px shadow-md flex flex-col justify-between">
            <div className="flex items-center gap-x-2 mb-3">
              <div className=""><Icon name="lightbulb" /></div>
              <h3 className="text-md font-bold">Training resources</h3>
            </div>
            <p className="flex-grow mb-3">
              Access comprehensive training materials, including video tutorials and interactive demos.
            </p>
            <a href="https://codethedream.org/vamos-training/" target="#" className="flex items-center justify-center p-2.5 rounded-md bg-vamos-v-light-gray hover:bg-vamos-light-gray">
              <span>View the training resources</span>
            </a>
          </div>
          <div className="w-1/3 p-4 bg-vamos-green1 rounded-10px shadow-md flex flex-col justify-between text-white">
            <div className="flex items-center justify-center gap-x-2 mb-3">
              <h3 className="text-md font-bold">Need immediate help?</h3>
            </div>
            <p className="flex-grow mb-3">Our support team is ready to assist you.</p>
            <a href="mailto:vamos@codethedream.org?subject=Need%20help%20with%20Vamos&body=Hello%20Vamos%20support%2C%0A%0AI%20need%20assistance%20with..." className="flex items-center justify-center space-x-4 p-2.5 rounded-md bg-vamos-black hover:bg-[#333333]">
              <span>Contact support</span>
            </a>
          </div>
        </div>
        <div className="border-t border-vamos-blue-gray pb-12" />
        <h2 className="text-lg font-medium">Submit a request</h2>
        <p className="pb-5.5">Found a bug? Report it below. You can also suggest a new feature.</p>
        <div className="flex space-x-4">
          <a
            href="https://codethedream.atlassian.net/jira/software/c/form/64bee577-9331-4d16-9d0b-4129c083f61c?atlOrigin=eyJpIjoiYmExNTVhYjdhZmZjNDc3MWExZDA4YjIzY2UyOTA2OTIiLCJwIjoiaiJ9"
            target="_blank"
            rel="noreferrer"
            className="flex items-center justify-center px-6 py-2.5 rounded-md bg-vamos-v-light-gray hover:bg-vamos-light-gray"
          >
            <span>Report a bug</span>
          </a>
          <a
            href="https://codethedream.atlassian.net/jira/software/c/form/0c045220-36ff-4bb3-ac3a-81becb012650"
            target="_blank"
            rel="noreferrer"
            className="flex items-center justify-center px-6 py-2.5 rounded-md bg-vamos-v-light-gray hover:bg-vamos-light-gray"
          >
            <span>Suggest a feature</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default HelpPage;

HelpPage.propTypes = {
};

